import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=8fbe9336&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"
import style0 from "./Section.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fbe9336')) {
      api.createRecord('8fbe9336', component.options)
    } else {
      api.reload('8fbe9336', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=8fbe9336&", function () {
      api.rerender('8fbe9336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Section.vue"
export default component.exports